import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/GENERAL/general";
import TODIS_FORM_ROADS_LIVE_DESC from "./form/GENERAL/rdescription";
import TODIS_FORM_ROADS_LIVE_STATUS from "./form/LP/lstatus";
import TODIS_FORM_ROADS_LIVE_ELEGPROJECT from "./form/GENERAL/relegibilityproject";
import TODIS_FORM_ROADS_LIVE_TENCOMPLIANCE from "./form/GENERAL/rtencompliance";
import TODIS_FORM_ROADS_LIVE_PERFOMANCE_INDICADOR from "./form/GENERAL/rperfomanceindicador";
import TODIS_ROADS_LIVE_FUND from "./form/LP/lFundingsources";
import TODIS_FORM_ROADS_LIVE_INDICATORS from "./form/GENERAL/rindicators";
import TODIS_FORM_ROADS_IMPNM from "./form/GENERAL/rimpnm";
import { TODIS_FORM_FIELD, TODIS_FORM_DSC, TODIS_FORM_FIELD_YES_NO } from "../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from "react-icons/bs";
import TODIS_TIMELINE from "./form/GENERAL/lTimeline";
import TODIS_TECH_DOCU from "./form/LP/lTechnicalDocumentation";
import TODIS_FORM_OTHER_ROADP from "./form/LP/other";
import { loadModules } from 'esri-loader';


const TODIS_FORM_LP = ({ errors, touched, status, setFieldValue, values }) => {

    const [statusTabDisabled, setStatusTabDisabled] = useState(true)

    useEffect(() => {
        try {
            const [Query, query] = loadModules(["esri/rest/support/Query", "esri/rest/query"]);
            console.log("Modules loaded", Query, query);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/19";
            console.log("Query URL:", queryUrl);

            let queryObject = new Query();
            queryObject.where = `live_road_proj_id=${values.liveRoadProjId}`;
            queryObject.returnGeometry = false;
            queryObject.outFields = "*";

            const results = query.executeQueryJSON(queryUrl, queryObject);

            if (results.features.length > 0) {
                setStatusTabDisabled(false);
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }

    })
    const generalTooltip = (
        <Tooltip id="general-tooltip">
            General data
        </Tooltip>
    );

    const descriptionTooltip = (
        <Tooltip id="description-tooltip">
            Project description
        </Tooltip>
    )

    const statusTooltip = (
        <Tooltip id="status-tooltip">
            Project implementation status
        </Tooltip>
    )

    const tentIndicatorsTooltip = (
        <Tooltip id="tent-indicators-tooltip">
            The TEN-T indicators the project will be addressing
        </Tooltip>
    )

    const tentComplianceTooltip = (
        <Tooltip id="tent-compliance-tooltip">
            Current compliance of the road section the project is related to
        </Tooltip>
    )

    const perfIndicatorsTooltip = (
        <Tooltip id="perfIndicators-tooltip">
            Project's compliance indicators
        </Tooltip >
    )

    const fundSourcesTooltip = (
        <Tooltip id="fundSources-tooltip">
            Project's funding sources
        </Tooltip>
    )

    const techDocuTooltip = (
        <Tooltip id="techDocu-tooltip">
            Project's technical documentation
        </Tooltip>
    )

    const otherTootltip = (
        <Tooltip id="other-tooltip">
            Other parameters related data
        </Tooltip>
    );


    return (
        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="General" title={
                <OverlayTrigger placement="top" overlay={generalTooltip}>
                    <div>General</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL errors={errors} touched={touched} disabled={status} TypeForm="" TetCategory="tenTCategory" setFieldValue={setFieldValue} values={values} />
                        {/* <Col lg={6}>
                            <TODIS_FORM_FIELD id="targetTentSec" label="Targeted TEN-T section(s) (current network layout)" name="targetTentSec" disabled={status}/>
                            {errors.targetTentSec && touched.targetTentSec ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.targetTentSec}</div>) : null}
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="newTentSec" label="New TEN-T section(s) (after project's implementation)" name="newTentSec" disabled={status}/>
                            {errors.newTentSec && touched.newTentSec ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.newTentSec}</div>) : null}
                        </Col> */}
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="immedPartTentNet" label="Part of TEN-T Network After Finalization" name="immedPartTentNet" disabled={status} />
                            {errors.immedPartTentNet && touched.immedPartTentNet ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.immedPartTentNet}</div>) : null}
                        </Col>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status} />
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="lDescription" title={
                <OverlayTrigger placement="top" overlay={descriptionTooltip}>
                    <div>Description</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_ROADS_LIVE_DESC errors={errors} touched={touched} disabled={status} TypeForm="roadsLivePmDescDTO" setFieldValue={setFieldValue} values={values} />
                    </Row>
                    <Col lg={12}>
                        <TODIS_FORM_DSC id="roadsLivePmDescDTO.remarks" label="Remarks" name="roadsLivePmDescDTO.remarks" disabled={status} />
                        {errors.roadsLivePmDescDTO && errors.roadsLivePmDescDTO.remarks && touched.roadsLivePmDescDTO && touched.roadsLivePmDescDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.roadsLivePmDescDTO.remarks}</div>) : null}
                    </Col>
                </Container>
            </Tab>
            <Tab eventKey="lStatus" title={
                <OverlayTrigger placement="top" overlay={statusTooltip}>
                    <div>Status</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_ROADS_LIVE_STATUS errors={errors} touched={touched} disabled={status} TypeForm="roadsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lFund" title={
                <OverlayTrigger placement="top" overlay={fundSourcesTooltip}>
                    <div>Funding sources</div>
                </OverlayTrigger>
            }>
                <TODIS_ROADS_LIVE_FUND errors={errors} touched={touched} disabled={status} TypeForm="roadsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lTechDocu" title={
                <OverlayTrigger placement="top" overlay={techDocuTooltip}>
                    <div>Technical documentation</div>
                </OverlayTrigger>
            }>
                <TODIS_TECH_DOCU errors={errors} touched={touched} disabled={status} TypeForm="roadsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lTimeline" title="Timeline">
                <TODIS_TIMELINE errors={errors} touched={touched} disabled={status} TypeForm="roadsLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lElegibilityProject" title={
                <OverlayTrigger placement="bottom" overlay={tentIndicatorsTooltip}>
                    <div>Targeted TEN-T indicators</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_ROADS_LIVE_ELEGPROJECT errors={errors} touched={touched} disabled={status} TypeForm="roadsLivePmEligiTentDTO" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="roadsLivePmEligiTentDTO.remarks" label="Remarks" name="roadsLivePmEligiTentDTO.remarks" disabled={status} />
                            {errors.roadsLivePmEligiTentDTO && errors.roadsLivePmEligiTentDTO.remarks && touched.roadsLivePmEligiTentDTO && touched.roadsLivePmEligiTentDTO.remmarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.roadsLivePmEligiTentDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="lTenCompliance" title={
                <OverlayTrigger placement="bottom" overlay={tentComplianceTooltip}>
                    <div>TEN-T compliance of the related road section</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_ROADS_LIVE_TENCOMPLIANCE errors={errors} touched={touched} disabled={status} TypeForm="roadsLivePmTentcompDTO" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="roadsLivePmTentcompDTO.remarks" label="Remarks" name="roadsLivePmTentcompDTO.remarks" disabled={status} />
                            {errors.roadsLivePmTentcompDTO && errors.roadsLivePmTentcompDTO.remarks && touched.roadsLivePmTentcompDTO && touched.roadsLivePmTentcompDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.roadsLivePmTentcompDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {/* Tab eventKey="lPerfomanceIndicador" title="Performance Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_ROADS_LIVE_PERFOMANCE_INDICADOR errors={errors} touched={touched} disabled={status} TypeForm="roadsLivePmPiDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="roadsLivePmPiDTO.remarks" label="Remarks" name="roadsLivePmPiDTO.remarks" disabled={status}/>
                            {errors.roadsLivePmPiDTO && errors.roadsLivePmPiDTO.remarks && touched.roadsLivePmPiDTO && touched.roadsLivePmPiDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.roadsLivePmPiDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab> */}
            <Tab eventKey="lIndicators" title={
                <OverlayTrigger placement="bottom" overlay={perfIndicatorsTooltip}>
                    <div>Performance indicators</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_ROADS_LIVE_INDICATORS errors={errors} touched={touched} disabled={status} TypeForm="roadsLivePmIndicatorsDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="roadsLivePmIndicatorsDTO.remarks" label="Remarks" name="roadsLivePmIndicatorsDTO.remarks" disabled={status} />
                            {errors.roadsLivePmIndicatorsDTO && errors.roadsLivePmIndicatorsDTO.remarks && touched.roadsLivePmIndicatorsDTO && touched.roadsLivePmIndicatorsDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.roadsLivePmIndicatorsDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Mpnm" title="MP">
                <Container>
                    <Row>
                        <TODIS_FORM_ROADS_IMPNM errors={errors} touched={touched} disabled={status} TypeForm="roadsLiveNmDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="roadsLiveNmDTO.remarks" label="Remarks" name="roadsLiveNmDTO.remarks" disabled={status} />
                            {errors.roadsLiveNmDTO && errors.roadsLiveNmDTO.remarks && touched.roadsLiveNmDTO && touched.roadsLiveNmDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.roadsLiveNmDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {statusTabDisabled ? null :
                <Tab eventKey="Other" title={
                    <OverlayTrigger placement="bottom" overlay={otherTootltip}>
                        <div>Others</div>
                    </OverlayTrigger>
                }>
                    <Container>
                        <Row>
                            <TODIS_FORM_OTHER_ROADP errors={errors} touched={touched} disabled={status} TypeForm="roadsLiveOtherDTO" values={values} />
                        </Row>
                    </Container>
                </Tab>
            }
        </Tabs>
    )
}

export default TODIS_FORM_LP;